import { PaginatedSocialSecurityQueryVariables } from "@/graphql/__generated__/graphql";
import DateRangeFilter from "../../Shared/DateRangeFilter";
import { format } from "date-fns";

interface Props {
  displayAmount: number;
  handleSubmitClick: (_variables?: PaginatedSocialSecurityQueryVariables) => void;
}

/**
 * SocialSecurityDateRange component for filtering social security by date range
 * @param props Component properties
 * @returns JSX element
 */
function SocialSecurityDateRange({ displayAmount, handleSubmitClick }: Props) {
  const socialSecurityDateConfig = {
    paginationStateKey: "paginatedSocialSecurity" as keyof PaginationState,
    dateFieldName: "activeFrom",
    buildQueryVariables: (
      displayAmount: number,
      filters: any,
      dateRange: { gte: Date | null; lte: Date | null },
      sort?: any
    ): PaginatedSocialSecurityQueryVariables => ({
      first: displayAmount,
      filters: {
        activeFrom: (dateRange.gte === null && dateRange.lte === null) ? null : {
          gte: dateRange.gte ? format(dateRange.gte, "yyyy-MM-dd") + "T00:00:00+00:00" : null,
          lte: dateRange.lte ? format(dateRange.lte, "yyyy-MM-dd") + "T23:59:59+00:00" : null,
        },
        value: filters.value || null
      },
      sort: sort
    }),
    extractFilters: (paginationState: any) => ({
      activeFrom: paginationState.filters?.activeFrom,
      value: paginationState.filters?.value,
    })
  };

  return (
    <DateRangeFilter
      displayAmount={displayAmount}
      handleSubmitClick={handleSubmitClick}
      config={socialSecurityDateConfig}
    />
  );
}

export default SocialSecurityDateRange;
